export default __webpack_public_path__ + "static/media/ui_icon_trash.21fd250f.svg";